export const d = "data";
export const m = "meta";
//# sourceMappingURL=reducer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/fx-schema-form-react/libs/reducers/reducer.js
// module id = 139
// module chunks = 3